import React, { createContext, useContext } from 'react';

const DirectoryNodesContext = createContext();

export const DirectoryNodesProvider = ({
  children,
  directoryNodes,
  setDirectoryNodes,
  closeParentAndChildren,
  openFolderAndCloseSiblings,
  updateNode,
  setSelectedFolder,
  selectedFolder,
  rrhh
}) => {
  const value = {
    directoryNodes,
    setDirectoryNodes,
    closeParentAndChildren,
    openFolderAndCloseSiblings,
    updateNode,
    setSelectedFolder,
    selectedFolder,
    rrhh
  };

  return <DirectoryNodesContext.Provider value={value}>{children}</DirectoryNodesContext.Provider>;
};

export const useDirectoryNodes = () => {
  const context = useContext(DirectoryNodesContext);
  if (!context) {
    throw new Error('useDirectoryNodes must be used within a DirectoryNodesProvider');
  }
  return context;
};
